export const walletTransactionsFeatureName = 'walletTransactions';
